// extracted by mini-css-extract-plugin
export default {"canvas":"SignCard_canvas__AaGsg"};